import { BasePath } from 'constants/basePath';
import React from 'react';
import { BlogType, EventType } from 'types';

import { NewsCard } from './News';
import { TopPostTitle } from './common/TopPostTitle';

interface Props {
  topPost: EventType | BlogType;
  basePath?: string;
}

export const MostFeaturedPost = ({
  topPost,
  basePath = BasePath.EventsBasePath
}: Props) => {
  if (!topPost) return null;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { title, sapo, slug } = topPost;

  return (
    <div className="w-[1280px] px-4 md:px-[40px] xl:px-[80px]">
      <div className="w-full grid grid-cols-1 md:grid-cols-13 mb-[40px]">
        <div className="hidden md:block md:col-span-8">
          <NewsCard
            basePath={basePath}
            news={topPost}
            isHottestNews={true}
            imageWidth={'700'}
            imageHeight={'400'}
          />
        </div>
        <div className="col-span-1 md:hidden">
          <NewsCard basePath={basePath} news={topPost} isHottestNews={true} />
        </div>
        <div className="col-span-5 relative">
          <TopPostTitle
            title={title}
            subTitle={sapo}
            basePath={basePath}
            slug={slug}
          />
        </div>
      </div>
    </div>
  );
};
